export default {unions:{RegistryItemInterface:{spreads:{BioentitySummary:{}}},InaccessibleInfoNode:{spreads:{InaccessibleInfo:{}}}}}